export const headerData = {
    name: 'Arijit Das',
    title: "Web Developer",
    desciption:"Behind every great website, there's a backend developer who knows that even servers need a little 'byte' of humor now and then! 🖥️💡",
    image: 'https://avatars.githubusercontent.com/u/88399881?s=400&u=d06264de838a2268ee06686ca97e8967429ddc14&v=4',
    resumePdf: 'https://drive.google.com/file/d/1x0HY0TuzObeeHhTxPzDO4WSOo3HzghxC/view?usp=share_link'
}
